function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.654 3.5798C14.469 3.5798 13.185 3.3828 12 2.7898C10.815 2.1968 9.531 1.9998 8.346 1.9998C5.976 1.9998 4 2.7898 4 2.7898V4.9968V21.2468C4 21.6608 4.335 21.9968 4.75 21.9968C5.164 21.9968 5.5 21.6608 5.5 21.2468V13.0128C6.268 12.8338 7.26 12.6668 8.346 12.6668C9.531 12.6668 10.815 12.8638 12 13.4568C13.186 14.0488 14.469 14.2468 15.654 14.2468C18.024 14.2468 20 13.4568 20 13.4568V2.7898C20 2.7898 18.025 3.5798 15.654 3.5798Z",
  fill: "currentColor"
});

function SvgIconFlagFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlagFilled);
export default __webpack_public_path__ + "static/media/iconFlagFilled.1306d821.svg";
export { ForwardRef as ReactComponent };